import psHttp from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '../../config/constants';

export function getHighlightKeywordsApi(params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/highlight`,
        method: 'GET',
        params,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function setHighlightKeywordsApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/highlight`,
        method: 'POST',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getHighlightTemplate() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/highlight/list`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function saveHighlightTemplate(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/highlight/save`,
        method: 'POST',
        data,
        transformCode: true
    });
}


export function deleteHighlightTemplate(templateId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/highlight/${templateId}`,
        method: 'DELETE',
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}


export function updateHighlightTemplate(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/highlight`,
        method: 'PUT',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}
